import { render } from "./distributor_staff_form.vue?vue&type=template&id=3f164bb1&scoped=true"
import script from "./distributor_staff_form.vue?vue&type=script&lang=js"
export * from "./distributor_staff_form.vue?vue&type=script&lang=js"

import "./distributor_staff_form.vue?vue&type=style&index=0&id=3f164bb1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f164bb1"]])

export default __exports__